export default "__VITE_ASSET__CGpijC0E__"